import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

interface NotificationSubBodyProps {
  content: string;
}

export const NotificationSubBody: FC<NotificationSubBodyProps> = ({
  content,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        gap: 1.5,
        paddingLeft: "4px",
      }}
    >
      <Box
        sx={{
          width: "4px",
          borderRadius: "4px",
          backgroundColor: nawyTheme.nawy.colors.semantic.layer.accent,
          flexShrink: 0,
        }}
      />

      <Typography
        sx={{
          ...nawyTheme.nawy.typography.english.variants.body.xxs.regular,
          color: nawyTheme.nawy.colors.semantic.text.primary,
        }}
      >
        {content}
      </Typography>
    </Box>
  );
};
